import { ActionType, getType } from 'typesafe-actions';

import { axiosInterceptorActions } from './axiosInterceptor.actions';
import { RequestErrorData } from '../../types/requests';

export type ApiResponseState = {
  requestError: RequestErrorData | null;
  isSomeApiFetching: boolean,
  isApiCausedPageError: boolean;
};

const initialState = {
  requestError: null,
  isSomeApiFetching: false,
  isApiCausedPageError: false,
};

export const axiosInterception = (state: ApiResponseState = initialState, action: ActionType<typeof axiosInterceptorActions>) => {
  switch (action.type) {
    case getType(axiosInterceptorActions.setRequestError):
      return {
        ...state,
        requestError: action.payload,
      };
    case getType(axiosInterceptorActions.setSomeApiFetching):
      return {
        ...state,
        isSomeApiFetching: action.payload,
      };
    case getType(axiosInterceptorActions.setApiCausedPageError):
      return {
        ...state,
        isApiCausedPageError: action.payload,
      };

    default:
      return state;
  }
};